module.exports = __webpack_public_path__ + "static/media/icon-bgDown.3c5e9294.svg";